export default __webpack_public_path__ + "static/media/2003-IMcover.504b68b7.jpg";